@if (embedToken && embedUrl) {
    <app-powerbi-embed [embedUrl]="embedUrl" [embedToken]="embedToken"></app-powerbi-embed>
}